import { createContext, useState } from 'react';
import api from 'services/api';
import moment from 'moment';

const filter = {
  like: '',
  id: '',
  entidade: [],
  dtvenc: {
    i: null,
    f: moment().format('YYYY-MM-DD'),
  },
  valor: '',
  vendedor: [],
  filial: [],
  dtemissao: {
    i: null,
    f: null,
  },
  observacao: '',
  banco: [],
  agencia: '',
  conta: '',
  cheque: '',
  nome: '',
  alinea: [],
};

export const ChequesPendentesContext = createContext();

export const ChequesPendentesProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [putLoading, setPutLoading] = useState(false);
  const [chequesPendentes, setChequesPendentes] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getChequesPendentes = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: chequesPendentes?.filter,
        page: chequesPendentes?.page,
        size: chequesPendentes?.size,
        order: chequesPendentes?.order,
        ...payload,
      });
      setChequesPendentes((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const putCheque = async ({ data, cb }) => {
    try {
      setPutLoading(true);
      await api.put('/Financeiro/Pendencias/Cheque', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPutLoading(false);
    }
  };

  return (
    <ChequesPendentesContext.Provider
      value={{
        getLoading,
        getChequesPendentes,
        chequesPendentes,
        putCheque,
        putLoading,
      }}
    >
      {children}
    </ChequesPendentesContext.Provider>
  );
};
